import styled from "styled-components"
import { device } from "breakpoints"

export const Block = styled.div`
  padding: 0 0 30px;

  @media ${device.desktop} {
    padding-bottom: 112px;
  }
`

export const Title = styled.h3`
  font-size: 38px;
  border-top: 1px solid rgba(158, 157, 168, 0.34);
  padding-top: 30px;
  color: ${props => props.theme.primaryColor};

  @media ${device.desktop} {
    font-size: 42px;
    padding-top: 44px;

  }
`
